module.exports = __webpack_public_path__ + "staticcomp/img/content_2.38256e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/5/content_2.jpg
// module id = BiJA
// module chunks = 39